var Promise = require('es6-promise').Promise;

module.exports = function getImagePromise(item) {
	return new Promise(function(resolve, reject) {
		var img;
		
		if(item.img) {
			img = new Image();
			img.src = item.img;
			item.img = img;
			item.img.onload = () => resolve(item);
		} else {
			resolve(item);
		}
	});
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/getImagePromise.js
 **/